import ProductCard from './ProductCard'
import { CategoryProduct } from '../Shop/Categories'
import { canAcceptOrders } from 'shop/utils/common'
import { useQueryParams, useShop } from 'shop/hooks'
import { FulfillmentType } from 'shop/types'
import { useMemo } from 'react'

export const Products = ({
  products,
  productCategory
}: {
  products: CategoryProduct[]
  productCategory: string
}) => {
  const { currentPartnerStore } = useShop()
  const { getQueryParam } = useQueryParams()

  const queryParamFulfillmentType =
    (getQueryParam('fulfillment_type').toUpperCase() as FulfillmentType) ||
    undefined

  const isStoreAcceptingOrders = useMemo(
    () => canAcceptOrders(currentPartnerStore, queryParamFulfillmentType),
    [currentPartnerStore, queryParamFulfillmentType]
  )

  return (
    <>
      {products.map((product, index) => {
        return (
          product && (
            <li key={product.id}>
              <ProductCard
                product={product}
                productCategory={productCategory}
                isLast={index === products.length - 1}
                isStoreAcceptingOrders={isStoreAcceptingOrders}
                source='SHOP_PAGE'
              />
            </li>
          )
        )
      })}
    </>
  )
}
